// "Passengers" card of a charter booking: who booked it, and the passenger manifest.
import { Card, Space, Typography } from 'antd';

import type { CharterBookingDetail } from '../../api/types';
import { CharterPassengers } from '../../components/CharterPassengers';

const { Text } = Typography;

export function PassengersCard({
  b,
  onChanged,
}: {
  b: CharterBookingDetail;
  onChanged: (fresh: unknown) => void;
}) {
  return (
    <Card title="Passengers">
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <Text type="secondary">
          Booked by {b.user?.name || '—'}
          {b.user?.email ? ` · ${b.user.email}` : ''}
          {b.user?.phone ? ` · ${b.user.phone}` : ''}
        </Text>
        <CharterPassengers
          bookingId={b.id}
          passengers={b.passengers}
          // SHAR-687 — the quoted aircraft's seats, so the manifest cannot
          // outgrow it. Same field the Flight information block prints above.
          seatingCapacity={b.seatingCapacity}
          onChanged={onChanged}
        />
      </Space>
    </Card>
  );
}
